import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LineAppearanceReport } from '../../../shared/models/generated/ziroModels';

@Injectable()
export class LineAppearanceManagementReportResource {
  private http = inject(HttpClient);

  get(cucmServerId: number, uuid: string): Observable<LineAppearanceReport> {
    return this.http.get<LineAppearanceReport>(
      `/services/cisco/reporting/line-appearance-report/cucm/${cucmServerId}/directory-number/${uuid}`,
    );
  }
}
